import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Home/Home.css";

const Home = () => {
    const navigate = useNavigate();


    const templates = [
        {name: "Static Website", route: "/StaticWebsite"},
        {name: "Serverless API", route: "/ServerlessApi"},
        {name: "Container Web App", route: "/ContainerWebApp"},
        {name: "Event Driven Notifications", route: "/EventDrivenNotifications"},
        {name: "Custom VPC", route: "/CustomVpc"},
        {name: "Transit Gateway", route: "/TransitGateway"}
    ]
    
    return (
        <div className="home-page"> 
            <div className="title-container">
                <h1>AWS-CDK-Templates</h1>
                <a className="repo-link" href="https://github.com/DylanTyberg/aws-cdk-templates" target="_blank" rel="noopener noreferrer">Repository</a>
            </div>
            <div className="home-container">
            
                {templates.map((t, index) => (
                    <div className="template-card" onClick={() => navigate(t.route)}>
                        <h1 className="template-name">{t.name}</h1>
                    </div>
                ))}
            </div>
        </div>
        
    )
}

export default Home;